import { render, staticRenderFns } from "./viewIt.vue?vue&type=template&id=0faaf7ef&scoped=true&"
import script from "./viewIt.vue?vue&type=script&lang=ts&"
export * from "./viewIt.vue?vue&type=script&lang=ts&"
import style0 from "./viewIt.vue?vue&type=style&index=0&id=0faaf7ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faaf7ef",
  null
  
)

export default component.exports